var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header__container"},[_c('div',{staticClass:"logged__user"},[_c('div',{staticClass:"sideMenuHeader"},[_vm._v("Logged in as "+_vm._s(_vm.store.state.user.role))]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon__holder"},[_c('img',{attrs:{"src":require("./../../assets/noun_profile.svg"),"alt":"Account logo"}})])
}]

export { render, staticRenderFns }